<template>
  <div id="main-wrapper">
    <b-overlay
        id="overlay-background"
        :show="isBusy"
        variant="white"
        spinner-variant="success"
        :opacity="1"
    >
      <template #overlay>
        <div class="text-center">
          <b-icon icon="clock" font-scale="3" animation="cylon" variant="orange"></b-icon>
          <p id="cancel-label"><span class="text-orange font-weight-bold">Παρακαλώ περιμένετε...</span></p>
        </div>
      </template>
      <router-view/>
    </b-overlay>
  </div>
</template>

<script>


import {mapState} from "vuex";
import AuthServices from "@/service/AuthServices";

export default {
  name: 'App',
  components: {},
  computed: {
    ...mapState(
        {
          isBusy: state => state.contract.isBusy
        },
    ),
  },
  async created() {
    window.addEventListener('beforeunload', function (e) {
      e.preventDefault();
      e.returnValue = '';
    });
    if (!this.$store.getters['auth/isAuthenticated']) {
      await this.$store.dispatch('logout')
      await this.$router.push('/');

    }
    const urlData = "?__csy=" + this.$cookies.get("__csy");
    let response = await AuthServices.getCaptions(urlData)
    if (response.status === 200 && response.data !== null) {
      await this.$store.dispatch("caption/setCaptions", response.data);
    }
  }
}
</script>

<style>
.session-timer {
  position: fixed;
  left: 20px;
  bottom: 10px;
  cursor: pointer;
  width: 3px;
  color: #fff;
  -webkit-transition: all .5s;
  -moz-transition: all .5s;
  -o-transition: all .5s;
  -ms-transition: all .5s;
  transition: all .5s;
}
</style>
